// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_pg-0";
export var buttonContainer = "_pg-3";
export var cancelButton = "_pg-4";
export var headerSection = "_pg-6";
export var headerTitle = "_pg-9";
export var messageSideLeft = "_pg-1";
export var messageSideRight = "_pg-2";
export var orderNumberContainer = "_pg-7";
export var orderNumberLabel = "_pg-8";
export var submitButton = "_pg-5";